export class HistoryDiagramCalculator {
    public static getAnswersScaleSteps(maxAnswers: number): number {
        const minRequiredMax = maxAnswers > 0 ? Math.ceil(maxAnswers / 0.3) : 10;
        const allowSteps = [5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000];
        const rawStep = minRequiredMax / 10;
        for (const step of allowSteps) {
            if (step >= rawStep) {
                return step
            }
        }
        return Math.pow(10, Math.ceil(Math.log10(rawStep)));
    }

    public static getTicsForAnswerSteps(steps: number): { value: number, label: string }[] {
        const ticks = [];
        for (let i = 0; i <= 3; i++) {
            const value = i * steps;
            ticks.push({value, label: value.toString()});
        }
        return ticks;
    }
}
